import React from "react";
import { Flex, Input } from "@fluentui/react-northstar";

export interface IInputWithLabel {
    label: string;
    value?: string;
    maxLength?: number;
    selectTextOnClick?: boolean;
    disabled?: boolean;
    onChange?: (event: any, value: any) => void;
}

const InputWithLabel: React.FunctionComponent<IInputWithLabel> = ({
    label, value, maxLength, selectTextOnClick, disabled, onChange
}) => {
    const inputRef: React.RefObject<HTMLInputElement> = React.createRef();
    return (
        <Flex column gap="gap.smaller">
            <small>{label}</small>
            <Input
                value={value}
                fluid
                onChange={onChange}
                maxLength={maxLength}
                disabled={disabled}
                onClick={selectTextOnClick ? () => inputRef.current?.select() : undefined}
                ref={inputRef}
            />
        </Flex>
    );
};

export default InputWithLabel;
